import { useEffect, useState } from 'react';

import { Snapshot } from '@candu-ai/snapshots/types';
import { fetchSnapshotNode } from '@candu-ai/snapshots/utils';

export const useLoadedSnapshots = (currentSnapshot?: Snapshot) => {
  const [loading, setLoading] = useState(!!currentSnapshot);
  const [loadedSnapshots, setLoadedSnapshots] = useState({
    sm: undefined,
    md: undefined,
    lg: undefined,
  });

  useEffect(() => {
    if (!currentSnapshot) {
      return;
    }

    setLoading(true);
    const promises = [
      fetchSnapshotNode(currentSnapshot?.smS3Url),
      fetchSnapshotNode(currentSnapshot?.mdS3Url),
      fetchSnapshotNode(currentSnapshot?.lgS3Url),
    ];

    Promise.all(promises).then(([sm, md, lg]) => {
      setLoadedSnapshots({
        sm,
        md,
        lg,
      });
      setLoading(false);
    });
  }, [currentSnapshot]);

  return {
    loadedSnapshots,
    loading,
  };
};
